import React, { useEffect, useState } from "react";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useDispatch, useSelector } from "react-redux";
import ErrorModal from "../Security/ErrorModal";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import CustomDropdown from "../../CustomControls/dropdown";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { renderAsync } from "docx-preview";
import { PDFDocument } from 'pdf-lib'; // For PDF processing
import UTIF from "utif";
import  loadImage  from "image-promise";
import DrugDetailsModal from "./DrugDetailsModal";
import mammoth from 'mammoth';
import { de } from "@faker-js/faker";

const Request_New_Authorization = () => {
  const location = useLocation();
  const { selectedRxItem = {}, DrugNames = [], PharmNames = [] } = location.state || {};
console.log("Selected RX Item:", selectedRxItem);
  // Map RX item fields to local state/fields
  const [treatment, setTreatment] = useState(selectedRxItem.CPTDesc || "");
  const [dateFrom, setDateFrom] = useState(selectedRxItem.RequestFromDate || "");
  const [dateTo, setDateTo] = useState(selectedRxItem.RequestToDate || "");
  const [pharmacies] = useState(PharmNames);
  const [drugNames] = useState(DrugNames);
const token = localStorage.getItem("AccessToken");
     const userInfo = useSelector((state) => state.userData);
 const { t, i18n } = useTranslation();
   const ssoData = useSelector((state) => state.sso.ssoUserData);
   const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const navigate = useNavigate();
  const [drugName, setDrugName] = useState("");
  const [homeQty, setHomeQty] = useState("");
  const [numRefills, setNumRefills] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const fileInputRef = React.useRef();
const [selectedFiles, setSelectedFiles] = useState([]);
const [selectedPharmacy, setSelectedPharmacy] = useState(null);
const [requestedDate, setRequestedDate] = useState(null);
const [isFileError, setIsFileError] = useState(false);
const [showDrugModal, setShowDrugModal] = useState(false);
const [drugs, setDrugs] = useState([]);
const [shouldNavigateBack, setShouldNavigateBack] = useState(false);

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validation: ensure required fields
    if (!treatment) {
      setModalMessage("Treatment name is required.");
      setShowModal(true);
      return;
    }
    if (!requestedDate) {
      setModalMessage("Requested date is required.");
      setShowModal(true);
      return;
    }
    if (!selectedPharmacy) {
      setModalMessage("Pharmacy is required.");
      setShowModal(true);
      return;
    }
    if (!selectedFiles || selectedFiles.length === 0) {
      setModalMessage("Please upload your prescription document(s).");
      setShowModal(true);
      return;
    }
    if (!drugs.length) {
      setModalMessage("Please add at least one drug.");
      setShowModal(true);
      return;
    }
     await handleSendToWin();
    // Build DrugInfo array
    const DrugInfo = drugs.map(drug => {
      // Find NDC from drugNames array if not provided
      let ndc = drug.NDC;
      if (!ndc) {
        const found = drugNames.find(d => d.Name === drug.drugName);
        ndc = found ? found.NDC : "";
      }
      return {
        drugName: drug.drugName,
        qty: drug.homeQty,
        refills: drug.numRefills,
        NDC: ndc
      };
    });

    // Format dates as MM/DD/YYYY for reqStartDate, and MM-DD-YYYY for dateNeeded
    const reqStartDate = dateFrom ? new Date(dateFrom).toLocaleDateString('en-US') : "";
    const dateNeeded = requestedDate ? new Date(requestedDate).toLocaleDateString('en-US').replace(/\//g, '-') : "";

    // Build payload
    const payload = {
      memberId: userInfo.userData.MemberID,
      contract: userInfo.userData.ContractIdentified,
      EmailID: userInfo.userData.EmailID,
      treatmentName: treatment,
      treatmentAuth: selectedRxItem.FormattedAuthNo || "",
      reqStartDate,
      proName: selectedRxItem.ProviderName || "",
      DrugInfo,
      dateNeeded,
      DeviceType: "PatientPortal",
      pharmName: typeof selectedPharmacy === 'string' ? selectedPharmacy : (selectedPharmacy?.PharmacyName || selectedPharmacy?.name || "")
    };
    // debugger
    console.log("Payload for authorization request:", payload);
    try {
      const res = await axios.post(Endpoints.MemberReqRX,
        { _Params: JSON.stringify(payload) }
        , {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`,
        },
      });
      debugger
      console.log("Authorization request response:", res.data);
      if (res && res.data && res.data.result === 1) {
        setModalMessage("Authorization request submitted.");
        setShowModal(true);
        setShouldNavigateBack(true);
      } else if (res && res.data && res.data.message) {
        setModalMessage(res.data.message);
        setShowModal(true);
        setShouldNavigateBack(false);
      } else {
        setModalMessage("Failed to submit authorization request.");
        setShowModal(true);
        setShouldNavigateBack(false);
      }
    } catch (error) {
      setModalMessage("Failed to submit authorization request.");
      setShowModal(true);
      setShouldNavigateBack(false);
    }
  };
  const handleFileSelection = (event) => {
    const validExtensions = ["pdf", "tiff", "jpeg", "jpg", "bmp", "png"];
    const files = Array.from(event.target.files);
    let anyInvalidType = false;
    let anyTooLarge = false;
    let duplicateFound = false;

    // Check for duplicates with already selected files
    for (const file of files) {
      const isDuplicate = selectedFiles.some(
        f => f.name === file.name && f.size === file.size
      );
      if (isDuplicate) {
        duplicateFound = true;
        break;
      }
    }

    // Check for duplicates within the new files themselves
    const fileSignatures = new Set();
    for (const file of files) {
      const signature = `${file.name}_${file.size}`;
      if (fileSignatures.has(signature)) {
        duplicateFound = true;
        break;
      }
      fileSignatures.add(signature);
    }

    if (duplicateFound) {
      setModalMessage("Duplicate file(s) detected. Please select unique files only.");
      setIsFileError(true);
      setShowModal(true);
      return;
    }

    if ((files.length + selectedFiles.length) > 4) {
      setModalMessage("Maximum 4 files can be selected.");
      setShowModal(true);
      return;
    } 
    const validFiles = files.filter(file => {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
            anyInvalidType = true;
            return false;
        }
        if (file.size > 2 * 1024 * 1024) {
            anyTooLarge = true;
            return false;
        }
        return true;
    });

    if (anyInvalidType) {
        setModalMessage("Invalid file type. Only PDF, TIFF, JPEG, BMP, or PNG allowed.");
        setIsFileError(true);
        setShowModal(true);
        return;
    } else if (anyTooLarge) {
        setModalMessage("File size should not exceed 2MB.");
        setIsFileError(true);
        setShowModal(true);
        return;
    }

    if (validFiles.length > 0) {
      setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
      setModalMessage("File uploaded successfully.");
      setIsFileError(false);
      setShowModal(true);
    }
    if (event.target) {
        event.target.value = null;
    }
  };
  
  const handleViewFile = async (file) => {
    const fileType = file.type;
  
    if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        const fileArrayBuffer = await file.arrayBuffer();
        
        // Open a new window
        const newWindow = window.open("", "_blank");
        if (newWindow) {
            // Write basic HTML structure to new window
            newWindow.document.write(`
                <html>
                    <head>
                        <title>Document Preview</title>
                        <style>body { font-family: Arial, sans-serif; margin: 20px; }</style>
                    </head>
                    <body>
                        <div id="docx-preview"></div>
                    </body>
                </html>
            `);
            newWindow.document.close();
  
            // Render the document into the new window
            renderAsync(fileArrayBuffer, newWindow.document.getElementById("docx-preview"));
        }
    } else {
        // For other types, open directly
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
    }
  };
  const handleFileDelete = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  const handleBackClick = () => {
      navigate(-1); // Go back to the previous page
    };
    
const handleAddAnotherDrug = () => {
  setShowDrugModal(true);
};
const handleModalClose = () => {
  setShowModal(false);
  setIsFileError(false);
  if (shouldNavigateBack) {
    navigate(-1);
  }
};
 const calculateNoOfPages = async (file, fileType) => {
  try {
    if (fileType === "application/pdf") {
      const inputBytes = await file.arrayBuffer();
      const pdfDoc = await PDFDocument.load(inputBytes);
      return pdfDoc.getPageCount();
    } else if (fileType === "image/tiff") {
        const buffer = await file.arrayBuffer();
        const pages = UTIF.decode(buffer); // Decode TIFF file
        return pages.length; // Number of pages in the TIFF file
      } else if (
      fileType === "image/jpeg" ||
      fileType === "image/png" ||
      fileType === "image/bmp"
    ) {
      await loadImage(URL.createObjectURL(file));
      return 1; // Single-page image
    }
  } catch (error) {
    console.warn(`Error determining page count for ${file.name}:`, error);
  }
  return 1; // Default to 1 if unable to determine
};

const onBrowse = () => {
  const input = document.getElementById('fileInput');
  if (input) {
      input.value = null; // Always reset so change event fires even for same file
      input.click();
  }
};

 // Upload handler for WIN API
  const handleSendToWin = async () => {
    if (!selectedFiles) {
        setModalMessage("Please select a document.");
        setShowModal(true);
        return;
    }
    
        try {
            let fileID = 1; // Initialize FileID to start from 1
            const payloads = []; // Array to hold all file payloads
    
            for (const file of selectedFiles) {
                let noOfPages = 1;
    
                // Determine the number of pages based on file type
                try {
                    const fileType = file.type;
    
                    if (fileType === "application/pdf") {
                        const inputBytes = await file.arrayBuffer();
                        const pdfDoc = await PDFDocument.load(inputBytes);
                        noOfPages = pdfDoc.getPageCount();
                    } else if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                        const arrayBuffer = await file.arrayBuffer();
                        const content = await mammoth.extractRawText({ arrayBuffer });
                        const wordCount = content.value.split(/\s+/).length;
                        noOfPages = Math.ceil(wordCount / 500);
                    } else if (fileType === "text/plain") {
                        const textContent = await file.text();
                        const lineCount = textContent.split(/\r?\n/).length;
                        noOfPages = Math.ceil(lineCount / 50);
                    }
                } catch (pageError) {
                    console.warn(`Failed to determine page count for ${file.name}:`, pageError);
                }
    
                const fileToBase64 = (file) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(",")[1]);
                        reader.onerror = (error) => reject(error);
                        reader.readAsDataURL(file);
                    });
    
                const base64Data = await fileToBase64(file);
    
                // Create payload for each file
                const filePayload = {
                    FileID: fileID.toString(), // Use the incrementing FileID
                    FilePath: "",
                    FileName: file.name,
                    NoOFPages: noOfPages.toString(),
                    DocTypeDesc: "Prescriptions",
                    inputBytes: base64Data,
                    fileSize: file.size.toString(),
                    memberId: userInfo.userData.MemberID,
                    contract: userInfo.userData.ContractIdentified,
                    contractCode: "",
                    docTypeDescription: "Prescriptions",
                    DeviceType:"PatientPortal",
                    EmailID: userInfo.userData.EmailID
                };
    
                payloads.push(filePayload);
                fileID++; // Increment FileID for the next file
            }
            // debugger
    console.log("Payloads for upload:", payloads);
            // Send all files in a single request
            const response = await axios.post(
                Endpoints.UploadDocument,
                JSON.stringify(payloads),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            // debugger
    console.log("Upload response:", response.data);
            // Handle response where each file has a FilePath in response.data array
            const filePaths = response.data.map((file) => file.FilePath);
   
            // Prepare SendToWin payload for all files
            const sendToWinPayload = {
                _Params: JSON.stringify({
                    MemberID: userInfo.userData.MemberID,
                    Contract: userInfo.userData.ContractIdentified,
                    DoctypeDesc: "Prescriptions",
                    DeviceType: "PatientPortal", // or "iOS" if applicable
                    EmailID: userInfo.userData.EmailID,
                    UserName:"MAPP", 
                    GroupID: "",
                    AuthNo: "",
                    ProviderID: "",
                    Activity: "",
                    ReimbursementType: "",
                    TotalAmount: 0,
                    Speciality: "",
                    PhysicianName: "",
                    PhysicianTelNo: "",
                    PhysicianTaxNo: "",
                    ServiceType: "",
                    DocumentTypes:"",
                    Documents: response.data.map((file, index) => ({
                      NoOFPages: payloads[index].NoOFPages,
                      FilePath: file.FilePath,
                      FileID: payloads[index].FileID,
                      FileName: payloads[index].FileName,
                      DocTypeDesc: "Prescriptions",
                    })),
                }),
            };
            // debugger
    console.log("SendToWin payload:", sendToWinPayload);
            // Call SendToWin API
            const res = await axios.post(Endpoints.SendToWin, sendToWinPayload, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${token}`,
                },
            });
            // debugger
            console.log("SendToWin response:", res.data);
            if (res && res.data ) {
                setModalMessage("Document(s) uploaded and sent successfully.");
                setShowModal(true);
                setSelectedFiles([]);
            } else if (res && res.data && res.data.message) {
                setModalMessage(res.data.message);
                setShowModal(true);
            } else {
                setModalMessage("Failed to send document(s) to WIN.");
                setShowModal(true);
            }
        } catch (error) {
            setModalMessage("An error occurred while processing the documents.");
            setShowModal(true);
        }
    };



 return (
  <>
    {isHighmarkPortal ? (
      <>
        <div className="col-md-8 mt-4 d-flex inner-page-heading-wrapper mb-3">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>
          <h2 className="page-heading ms-2">{t('requestAuthorizationHeading')}</h2>          
        </div>
        <div className="col-md-4 d-flex align-items-center">
          <button
            className="win-btn-primary model-popup-btn me-2 mb-3 mb-sm-0 ms-auto"
            type="button"
            onClick={handleAddAnotherDrug}
          >
            {drugs.length > 0 ? "Add another drug" : "Add drug"}
          </button>
        </div>
      </>
    ) : (
      <>
        <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i> {t('Back')}
            </span>
          </button>
          <h2 className="page-heading">{t('requestAuthorizationHeading')}</h2>
        </div>
        <div className="col-md-6 d-flex align-items-end mb-3">
          <button className="win-btn-primary model-popup-btn me-2 mb-3 mb-sm-0 ms-auto" type="button" onClick={handleAddAnotherDrug}>
            {drugs.length > 0 ? "Add another drug" : "Add drug"}
          </button>
        </div>
      </>
    )}

    <div className="col-md-6">
      {/* keep instructions wrapper/class, but simplified text */}
      <p className="instructions">Please complete all fields below to request a new authorization. Once complete, our team will review and be in touch soon.</p>

      {/* ===== FORM (same classes kept) ===== */}
      <form className="form mt-4">
        {/* Treatment Name */}
        <div className="mb-2 row align-items-center">
          <label className="col-sm-4 model-form-label">Treatment Name</label>
          <div className="col-sm-8">
            <input
              type="text"
              className="form-control win-form-control  mobile-view"
              value={treatment || ''}
              readOnly
            />
          </div>
        </div>

        {/* Date Range (From / To) */}
        <div className="mb-2 row align-items-center">
          <label className="col-sm-4 model-form-label">Date Range</label>
          <div className="col-sm-8">
            <input
              type="text"
              className="form-control win-form-control  mobile-view"
              value={dateFrom && dateTo ? `${dateFrom} - ${dateTo}` : ''}
              readOnly
            />
          </div>
        </div>

        {/* Requested Date */}
        <div className="mb-2 row align-items-center">
          <label className="col-sm-4 model-form-label mandatory">Requested Date</label>
          <div className="col-sm-8">
            <DatePicker
              selected={requestedDate}
              onChange={setRequestedDate}
              id="date"
              dateFormat="MM/dd/yyyy"
              className="form-control win-form-control calendar-control mobile-view"
              placeholderText="MM/DD/YYYY"
              showYearDropdown
              scrollableYearDropdown
              minDate={new Date()}
              onKeyDown={(e) => e.preventDefault()}
              autoComplete="off"
            />
          </div>
        </div>

        {/* Pharmacy Name */}
        <div className="mb-2 row align-items-center">
          <label className="col-sm-8 model-form-label  mandatory">Pharmacy Name</label>
          <div className="col-sm-12 custom-dropdown-forced-380px-in-tab custom-dropdown-100pc-only-mobile">
            <CustomDropdown
              options={pharmacies}
              selectedOption={selectedPharmacy || ''}
              onChange={(val) => {
                setSelectedPharmacy(val);
              }}
              placeholder="Select a pharmacy"
              searchable
            />
          </div>
        </div>


        {/* Upload your prescription (keeps existing upload classes/wrapper) */}
        <div className="mb-4 row align-items-center">
          <label className="col-sm-8 model-form-label">Upload Your Prescription</label>
          <div className="col-sm-8">
            <div className="custom-file-upload-380px win-form-control request-auth-file-upload mobile-view">
              <input
                type="file"
                id="fileInput"
                className="file-input"
                onChange={handleFileSelection}
                multiple
                ref={fileInputRef}
                accept=".pdf, .tiff, .jpeg, .jpg, .bmp, .png"
              />
              <div className="input-display">
                <input type="text" className="file-text" placeholder={t('choosefileplaceholder')} readOnly />
                <button type="button" className="custom-button" onClick={onBrowse}>
                  {t('browse')}
                </button>
              </div>
            </div>

            {/* optional: show selected files in the same table wrapper/classes you already use */}
            

            {/* Upload action button (kept button class) */}
            {/* <button className="win-btn-secondary model-popup-btn me-3 mb-3 mb-sm-0" type="button" onClick={handleFileSelection}>
              Upload your prescription
            </button> */}
          </div>
        </div>

        


      </form>

      {/* Keep modals intact (same classes/props) */}
      <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose} />
      <DrugDetailsModal
  show={showDrugModal}
  onClose={() => setShowDrugModal(false)}
  onNext={({ drugName, homeQty, numRefills }) => {
    setDrugs(prev => [...prev, { drugName, homeQty, numRefills }]);
    setShowDrugModal(false);
  }}
  drugName={drugName}
  setDrugName={setDrugName}
  homeQty={homeQty}
  setHomeQty={setHomeQty}
  numRefills={numRefills}
  setNumRefills={setNumRefills}
  treatment={treatment}
  drugNames={drugNames}
/>


    </div>

    <div className="col-md-6 mt-0 mt-md-5">
      {/* Render added drugs as pill/cards */}
      {drugs.length > 0 && (
        <div className="mt-2 mt-md-5 authraisation-new-drug-wrapper">
          {drugs.map((drug, idx) => (
            <div key={idx} className="authraisation-new-drug-item">

              <table className="table mb-0">
                <thead>
                  <tr>
                    <th>Drug name</th>
                    <th width="80" className="text-center">Qty</th>
                    <th width="120" className="text-center">No. of refills</th>
                  </tr>
                </thead>
                <tbody>                  
                    <tr>
                      <td>{drug.drugName}</td>
                      <td className="text-center">{drug.homeQty}</td>
                      <td className="text-center">{drug.numRefills}</td>
                    </tr>               
                </tbody>
              </table>

              
              <button
                type="button"
                aria-label="Remove drug"
                style={{ background: 'none', border: 'none', color: '#ff0000', fontSize: 22, marginLeft: 8, cursor: 'pointer', position: 'absolute', right: 3, top: -5 }}
                onClick={() => setDrugs(drugs.filter((_, i) => i !== idx))}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
      
      <div className="mt-2">
        <table className="table">
          <thead className="winpay-table-header">
            <tr className="winpay-table-header">
              <th>{t('filenamelable')}</th>
              <th width="80" className="text-center">{t('btnview')}</th>
              <th width="80" className="text-center">{t('btndelete')}</th>
            </tr>
          </thead>
          <tbody>
            {selectedFiles.map((file, index) => (
              <tr className="winpay-table-row" key={index}>
                <td>{file.name}</td>
                <td className="text-center">
                  <button className="winpay-table-view-icon mx-auto" type="button" onClick={() => handleViewFile(file)} />
                </td>
                <td className="text-center">
                  <button className="winpay-table-trash-icon mx-auto" type="button" onClick={() => handleFileDelete(index)} />
                </td>
              </tr>
            ))}
            {selectedFiles.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center">{t('noFilesUploaded')}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    <div className="col-md-6">
      {/* Add another drug (keeps same row/classes) */}
        <div className="mb-4 row align-items-center">
          <label className="col-sm-4 model-form-label"></label>
          <div className="col-sm-8 d-flex">            
            <button className="win-btn-primary mobile-view" type="button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
    </div>
  </>
);

};

export default Request_New_Authorization;
